import { render, staticRenderFns } from "./VaultItemDropZone.vue?vue&type=template&id=60e61348"
import script from "./VaultItemDropZone.vue?vue&type=script&lang=js"
export * from "./VaultItemDropZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports